import { render, staticRenderFns } from "./XQYBorrowTable.vue?vue&type=template&id=6171f292&scoped=true&"
import script from "./XQYBorrowTable.vue?vue&type=script&lang=js&"
export * from "./XQYBorrowTable.vue?vue&type=script&lang=js&"
import style0 from "./XQYBorrowTable.vue?vue&type=style&index=0&id=6171f292&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171f292",
  null
  
)

export default component.exports